import Loadable from 'react-loadable';

import { LoadingPageLoadable } from 'modules/main/pages/Loading';

export const AdminsLinksLoadable = Loadable({
  loader: () =>
    import(
      /* webpackChunkName: "AdminsLinks" */
      './AdminsLinks.dynamic'
    ),
  loading: LoadingPageLoadable,
});
